var _path, _path2, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14949 8.5C8.19154 8.5 8.22562 8.53408 8.22562 8.57613V12.1818C8.22562 12.4487 8.00925 12.665 7.74235 12.665V12.665C7.47545 12.665 7.25908 12.4487 7.25908 12.1818V9.8704C7.25908 9.7287 7.12307 9.62667 6.98703 9.66631L6.76506 9.731C6.53595 9.79776 6.30688 9.62592 6.30688 9.38728V9.38728C6.30688 9.23462 6.40369 9.09875 6.54798 9.0489L8.12463 8.50417C8.13263 8.50141 8.14103 8.5 8.14949 8.5V8.5Z",
    fill: "#050022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62812 18.7562C8.8335 18.7562 9 18.9227 9 19.1281V19.1281C9 19.3335 8.8335 19.5 8.62812 19.5H6.53544C6.28724 19.5 6.08604 19.2988 6.08604 19.0506V19.0506C6.08604 18.9351 6.13051 18.824 6.21023 18.7405L7.4283 17.4632C7.54685 17.3278 7.64245 17.2067 7.71511 17.0999C7.78776 16.9912 7.84034 16.893 7.87285 16.8053C7.90727 16.7176 7.92447 16.6384 7.92447 16.5679C7.92447 16.4477 7.90631 16.3476 7.86998 16.2675C7.83556 16.1855 7.78394 16.1235 7.71511 16.0816C7.64818 16.0396 7.56501 16.0186 7.46558 16.0186C7.36616 16.0186 7.27916 16.0472 7.20459 16.1045C7.13002 16.1617 7.0717 16.2399 7.02964 16.339V16.339C6.95871 16.5142 6.8162 16.6737 6.62722 16.6737H6.4847C6.21701 16.6737 5.9898 16.4501 6.08055 16.1982C6.10854 16.1205 6.14383 16.0454 6.18642 15.9729C6.31262 15.7612 6.48757 15.5924 6.71128 15.4665C6.93499 15.3388 7.19407 15.2749 7.48853 15.2749C7.79637 15.2749 8.05449 15.3226 8.26291 15.4179C8.47132 15.5133 8.62811 15.6515 8.73327 15.8327C8.84034 16.012 8.89388 16.2284 8.89388 16.4821C8.89388 16.627 8.87094 16.7662 8.82505 16.8997C8.77916 17.0332 8.71319 17.1657 8.62715 17.2973C8.54111 17.427 8.43595 17.5605 8.31166 17.6978C8.18929 17.8351 8.04971 17.981 7.89293 18.1355L7.49755 18.5907C7.44132 18.6554 7.4873 18.7562 7.57305 18.7562H8.62812Z",
    fill: "#050022"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 9.5,
    width: 10,
    height: 2.47058,
    rx: 0.5,
    fill: "#050022"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 16.3,
    width: 10,
    height: 2.47058,
    rx: 0.5,
    fill: "#050022"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.ccbbf8850de7c9551ba5976d4c20b6ec.svg";
export { ForwardRef as ReactComponent };